<div class="mb-1 d-table col-12">
    <span class="pt-5 pb-2 col-12" translate="Settings.ApplicationReasonsLocationsSection.AvailableSigningMethods">
        <app-info-button
            labelName="Settings.ApplicationReasonsLocationsSection.AvailableSigningMethodsToolTip"></app-info-button>
    </span>
    <ul class="mb-3 mt-3 mx-0 list-group">
        <li class="list-group-item subheader d-block">
            <div class="row row-cols-12 d-flex align-items-center">
                <div class="col-6 firstcol"><span
                        translate="Settings.ApplicationReasonsLocationsSection.Description"></span>
                </div>
                <div class="col-3"><span translate="Settings.ApplicationReasonsLocationsSection.InternalUsers"></span>
                </div>
                <div class="col-3"><span translate="Settings.ApplicationReasonsLocationsSection.ExternalUsers"></span>
                </div>
            </div>
        </li>
        <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_Stamp">
            <li class="list-group-item d-block">
                <div class="row row-cols-12 d-flex align-items-center">
                    <div class="col-5 firstcol text-truncate"
                        translate="Settings.ApplicationReasonsLocationsSection.Stamp">
                    </div>
                    <div class="col"></div>
                    <div class="col-3 firstcol text-truncate float-none form-check form-switch">
                        <input class="switch-form-default float-none form-check-input items" type="checkbox"
                            (change)="toggleChanged($event)" role="switch" id="UseInternalStamp"
                            [checked]="signatureMethodSettings.UseInternalStamp"
                            [disabledByPermission]="permissionEnum.Perm_Stamp">
                    </div>
                    <div class="col-3 firstcol text-truncate float-none form-check form-switch">
                        <input class="switch-form-default float-none form-check-input items" type="checkbox"
                            (change)="toggleChanged($event)" role="switch" id="UseExternalStamp"
                            [checked]="signatureMethodSettings.UseExternalStamp"
                            [disabledByPermission]="permissionEnum.Perm_Stamp">
                    </div>
                </div>
            </li>
        </app-hide-by-permission-wrapper>
        <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_Drawing">
            <li class="list-group-item d-block">
                <div class="row row-cols-12 d-flex align-items-center">
                    <div class="col-5 firstcol text-truncate"
                        translate="Settings.ApplicationReasonsLocationsSection.Draw">
                    </div>
                    <div class="col"></div>
                    <div class="col-3 firstcol text-truncate float-none form-check form-switch">
                        <input class="switch-form-default float-none form-check-input items" type="checkbox"
                            (change)="toggleChanged($event)" role="switch" id="UseInternalDraw"
                            [checked]="signatureMethodSettings.UseInternalDraw"
                            [disabledByPermission]="permissionEnum.Perm_Drawing">
                    </div>
                    <div class="col-3 firstcol text-truncate float-none form-check form-switch">
                        <input class="switch-form-default float-none form-check-input items" type="checkbox"
                            (change)="toggleChanged($event)" role="switch" id="UseExternalDraw"
                            [checked]="signatureMethodSettings.UseExternalDraw"
                            [disabledByPermission]="permissionEnum.Perm_Drawing">
                    </div>
                </div>
            </li>

        </app-hide-by-permission-wrapper>
        <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_Pictures">
            <li class="list-group-item d-block">
                <div class="row row-cols-12 d-flex align-items-center">
                    <div class="col-5 firstcol text-truncate"
                        translate="Settings.ApplicationReasonsLocationsSection.Picture"></div>
                    <div class="col"></div>
                    <div class="col-3 firstcol text-truncate float-none form-check form-switch">
                        <input class="switch-form-default float-none form-check-input items" type="checkbox"
                            (change)="toggleChanged($event)" role="switch" id="UseInternalPicture"
                            [checked]="signatureMethodSettings.UseInternalPicture"
                            [disabledByPermission]="permissionEnum.Perm_Pictures">
                    </div>
                    <div class="col-3 firstcol text-truncate float-none form-check form-switch">
                        <input class="switch-form-default float-none form-check-input items" type="checkbox"
                            (change)="toggleChanged($event)" role="switch" id="UseExternalPicture"
                            [checked]="signatureMethodSettings.UseExternalPicture"
                            [disabledByPermission]="permissionEnum.Perm_Pictures">
                    </div>
                </div>
            </li>
        </app-hide-by-permission-wrapper>

    </ul>
</div>